/* ==================================================
  Collections Menu Toggle
================================================== */

var collectionFiltersToggle = document.getElementById('collection-filters-toggle');
var collectionFilters = document.getElementById('collection-filters');

collectionFiltersToggle.addEventListener('click', () => {  
  collectionFilters.classList.toggle('hidden');
})